import styled from '@emotion/styled';
import { H2, Text } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}));

export const PriceInfo = styled.div(({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`);

export const PriceInfoWrapper = styled.div(({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`);

export const CurrentPriceText = styled.div`
  ${({ theme }) => `
    font-size: ${typographyFontSizeCfg.h1.desktop}px;
    line-height: ${typographyLineHeightCfg.h1.desktop}px;
    font-weight: bold;
    color: ${theme.colors.neutrals.grey1};
  `};
`;

export const PrimaryAddressText = styled(H2.withComponent('h1'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `};
`;

export const SecondaryAddress = styled.div`
  display: flex;
  align-items: center;
`;

export const SecondaryAddressText = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey3};
  `};
`;

export const OfferDetailsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6.5),
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    gap: 'unset',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 5),
    borderRadius: theme.borderRadius.small,
    border: `1px solid ${theme.colors.neutrals.grey8}`,
    minHeight: theme.spacing(10),
    marginBottom: theme.spacing(3),
  },
}));

export const CurrentPrice = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  display: inline-block;
  ${({ theme }) => theme.isRTL ? '' : 'margin-left: 8px;'}
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    order: 0;
    margin-left: ${theme.spacing(1)};
  `};
`;

export const PreviousPrice = styled(Text)`
  ${({ theme }) => `
    margin-left: ${theme.spacing(1)};
    margin-right: ${theme.spacing(0.5)};
    color: ${theme.colors.neutrals.grey3};
    text-decoration-line: line-through;
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    margin-right: 0;
  `}
`;
